import type { PeriodTypesRepositoryT } from "../../domain/ports/periodTypes.repository";

type GetPeriodTypesParamsT = {
  periodTypesRepository: PeriodTypesRepositoryT;
};

export const getPeriodTypes = async ({
  periodTypesRepository,
}: GetPeriodTypesParamsT) => periodTypesRepository.getAll();
